import qs from "qs";

export const queryString = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});

export const appSettings = {
  ...window.config,
  ...queryString,
};
console.log("queryString", queryString);
console.log("appSettings", appSettings);

export const apiBaseUrl = appSettings?.apiBaseUrl ?? "";
console.log("apiBaseUrl", apiBaseUrl);
